import {
  AiOutlineEye,
  AiOutlineClose,
  AiOutlineEyeInvisible,
} from "react-icons/ai";
import { isEmpty } from "lodash";
import { useState } from "react";

const FormInput = ({
  id,
  label,
  error,
  value,
  touched,
  onFocus,
  onChange,
  placeholder,
  type = "text",
  disabled = false,
  closeItem = false,
}: {
  id?: string;
  value?: string;
  type?: string;
  label?: string;
  touched?: boolean;
  disabled?: boolean;
  closeItem?: boolean;
  placeholder?: string;
  error?: string | null;
  onFocus?: (() => void) | undefined;
  onChange: (text: string) => void;
}) => {
  const [isVisiblePassword, setIsVisiblePassword] = useState(false);

  return (
    <div className="w-full">
      {label && (
        <div className="flex flex-row justify-between w-full">
          <label
            htmlFor={id}
            className="block mb-2 text-sm font-medium text-valhalla"
          >
            {label}
          </label>
          {closeItem && (
            <button
              type="button"
              onClick={() => {}}
              className="flex items-center w-[22px] h-[22px] rounded-xl justify-center bg-deactivate hover:bg-deactivate-focus"
            >
              <AiOutlineClose size={15} color="#fff" />
            </button>
          )}
        </div>
      )}
      <div className="w-full relative flex flex-row">
        <input
          id={id}
          name={id}
          value={value}
          autoComplete={id}
          onFocus={onFocus}
          disabled={disabled}
          placeholder={placeholder}
          type={isVisiblePassword ? "text" : type}
          onChange={(e) => onChange(e.target.value)}
          className={`nl-input ${type === "password" ? "pr-10" : ""}`}
        />
        {type === "password" ? (
          <>
            {isVisiblePassword ? (
              <AiOutlineEye
                onClick={() => setIsVisiblePassword(!isVisiblePassword)}
                className="absolute right-4 top-3"
              />
            ) : (
              <AiOutlineEyeInvisible
                onClick={() => setIsVisiblePassword(!isVisiblePassword)}
                className="absolute right-4 top-3"
              />
            )}
          </>
        ) : null}
      </div>
      {!isEmpty(error) && touched && (
        <div className="mt-1 text-xs font-normal text-rose-400 leading-3">
          {error}
        </div>
      )}
    </div>
  );
};

export default FormInput;
